import '../styles/globals.css'
import { AlertProvider } from '../components/warning/AlertProvider'
import { useEffect } from 'react'
import { initializeAppInsights } from '../app-insights'

function MyApp({ Component, pageProps }) {
  useEffect(() => {
    initializeAppInsights({
      cloudRoleName: 'EHG-Website',
      cloudRoleInstance: process.env.NODE_ENV || 'production'
    });
  }, []);

  return (
    // <AlertProvider>
    //   <Component {...pageProps} />
    // </AlertProvider>
    <Component {...pageProps} />
  )
}

export default MyApp